<template>
  <div
    v-if="displayAlert"
    :class="[`mc-alert mc-alert__${variant} d-flex`, { 'mc-alert--with-gap': withGap }]"
  >
    <slot name="prefix"></slot>
    <i v-if="withIcon" class="mc-alert__icon" :class="[computedIcon, iconPositionClass]"></i>
    <div v-if="text" class="mc-alert__text">
      {{ text }}
    </div>
    <div v-if="html" class="mc-alert__text" v-html="html" />
    <slot name="label"></slot>
    <slot name="suffix"></slot>
    <i v-if="hasClose" class="mc-alert__icon-close icon-fill_close" @click="closeAlert()"></i>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'success',
    },
    text: {
      type: String,
      default: null,
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    iconVariant: {
      type: String,
      default: 'fill',
    },
    iconPosition: {
      type: String,
      default: 'top',
    },
    hasClose: {
      type: Boolean,
      default: false,
    },
    customIcon: {
      type: String,
      default: null,
    },
    withGap: {
      type: Boolean,
      default: true,
    },
    html: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      icon: {
        success: `icon-${this.iconVariant}_checkmark-circle`,
        info: `icon-${this.iconVariant}_info`,
        warning: `icon-${this.iconVariant}_alert-triangle`,
        error: `icon-${this.iconVariant}_slash`,
      },
      displayAlert: true,
    }
  },
  computed: {
    iconPositionClass() {
      return this.iconPosition === 'center' ? 'mc-alert__icon-position align-content-center' : ''
    },
    computedIcon() {
      if (this.customIcon !== null) {
        return this.customIcon
      }

      return this.icon[this.variant]
    },
  },
  methods: {
    closeAlert() {
      this.displayAlert = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-alert {
  min-height: 44px;
  padding: 12px;
  border-radius: 4px;
  &.mc-alert--with-gap {
    gap: 12px;
  }

  .mc-alert__icon {
    &.mc-alert__icon-position {
      display: flex;
      align-items: center;
    }
  }

  .mc-alert__icon-close {
    font-size: 20px;
    display: flex;
    align-items: center;
    &.icon-fill_close {
      cursor: pointer;
      &:before {
        color: $teal-200;
      }
    }
  }

  .mc-alert__icon:before {
    font-size: 20px;
    justify-content: center;
  }

  .mc-alert__text {
    width: 100%;
    color: #344264;
    font-size: 13px;
  }

  &.mc-alert__success {
    border: 1px solid #71b099;
    background-color: #e7f2ee;

    .mc-alert__icon:before {
      color: #137c55;
    }
  }

  &.mc-alert__info {
    border: 1px solid #1c74da;
    background-color: #deeafc;

    .mc-alert__icon:before {
      color: #2952cc;
    }
  }

  &.mc-alert__warning {
    border: 1px solid #ffb966;
    background-color: #fff3e6;

    .mc-alert__icon:before {
      color: #ff8a00;
    }
  }

  &.mc-alert__error {
    border: 1px solid #f87766;
    background-color: #fee8e5;

    .mc-alert__icon:before {
      color: #f41d00;
    }
  }
}
</style>
